import React, { useState, useContext } from "react";
import "./ToggleBtn.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

function RotatingPricingSection() {
  const { isSubscribed, plan } = useContext(AuthContext);
  const location = useLocation();
  let url_plan = new URLSearchParams(location.search).get("plan");
  let degree = 0;
  if (url_plan === "annual") {
    degree = -120;
  } else if (url_plan === "clinics") {
    degree = -240;
  }
  const [rotation, setRotation] = useState(degree);
  const rotateTo = (degrees) => {
    setRotation(degrees); // Update rotation state
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };



  const handleRadioChange = (value) => {
    switch (value) {
      case "checkbox1":
        rotateTo(0);
        break;
      case "checkbox2":
        rotateTo(-120);
        break;
      case "checkbox3":
        rotateTo(-240);
        break;
      default:
        break;
    }
  };

  const handleCanelMonthlyPlan = () => {
    
  };


  return (
    <>
      <div className="carosusel-div">
        <p className="mt-5 mb-5 font-medium text-[20px] text-center dark:text-white">
          Choose a subscription plan
        </p>
        {/* Mobile: Show toggle buttons for carousel */}
        <div className="toggle-btn flex justify-center lg:hidden">
          <div className="toggle-container">
            <input
              type="radio"
              value="theme"
              name="theme"
              className="checkbox1"
              id="checkbox1"
              onChange={() => handleRadioChange("checkbox1")}
              defaultChecked={degree === 0}
            />
            <label htmlFor="checkbox1" className="checkbox1 text-white">
              Monthly
            </label>

            <input
              type="radio"
              value="theme"
              name="theme"
              className="checkbox2"
              id="checkbox2"
              onChange={() => handleRadioChange("checkbox2")}
              defaultChecked={degree === -120}
            />
            <label htmlFor="checkbox2" className="checkbox2 text-white">
              Annual
            </label>

            <input
              type="radio"
              value="theme"
              name="theme"
              className="checkbox3"
              id="checkbox3"
              onChange={() => handleRadioChange("checkbox3")}
              defaultChecked={degree === -240}
            />
            <label htmlFor="checkbox3" className="checkbox3 text-white">
              Clinics
            </label>
            <div className="round"></div>
          </div>
        </div>
        <div className="flex justify-center items-center">
          {/* Mobile: Carousel mode */}
          <div className="container-caro 2xl:mt-20 xl:mt-20 md:mt-20 mt-14 lg:hidden">
            <div
              className="carousel"
              style={{ transform: `rotateY(${rotation}deg)` }}
            >
              <div className="carousel__face" id="slide1">
                <div className="card-3d-wrap ">
                  <div className="card-3d-wrapper">
                    <div className="card-front">
                      <div className="pricing-wrap bg-[#cbd5e1] dark:bg-[#222A32] rounded-md shadow-lg hover:shadow-xl transition-shadow duration-300">
                        <p className="dark:text-white text-[16px] font-semibold text-center mb-4">
                          Unlimited Access: Monthly
                        </p>
                        {/* BETA: Price hidden
                        <h4 className="mb-5 mt-5 dark:text-white">
                          $152 <span className="text-[15px]">per month</span>
                        </h4>
                        */}
                        <div className="p-4">
                          <table className="text-[14px] dark:text-white">
                            <tbody>
                              <tr className="">
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Unlimited 24/7 Access: Get round-the-clock
                                  availability to therapy whenever you need it
                                </td>
                              </tr>
                              <tr>
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Comprehensive Tools: Explore and use the full
                                  suite of speech therapy assessments and
                                  exercises
                                </td>
                              </tr>
                              <tr>
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Innovative Therapy: Engage in interactive
                                  avatar-led therapy session for a personalized
                                  experience
                                </td>
                              </tr>
                              <tr>
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Rolling monthly plan,renews automatically
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {/* BETA: Selection buttons removed - features only display */}

                        <div className="img-wrap img-2">
                          <img
                            src="/logo_for_pricing_dark2.jpeg"
                            alt="IzzyAI logo - AI-powered solution for Speech Language Therapy, offering tailored therapy for stammering, articulation, voice disorders, receptive disorders, and expressive disorders."
                            className="rounded-md dark:hidden"
                            width={"auto"}
                            height={"auto"}
                            loading="lazy"
                          />
                          <img
                            src="/logo_for_pricing_light2.jpeg"
                            alt="IzzyAI logo - AI-powered solution for Speech Language Therapy, offering tailored therapy for stammering, articulation, voice disorders, receptive disorders, and expressive disorders."
                            className="rounded-md hidden dark:block"
                            width={"auto"}
                            height={"auto"}
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel__face" id="slide2">
                <div className="card-3d-wrap mx-auto ">
                  <div className="card-3d-wrapper">
                    <div className="card-front">
                      <div className="pricing-wrap bg-[#cbd5e1] dark:bg-[#222A32] rounded-md shadow-lg hover:shadow-xl transition-shadow duration-300">
                        <p className="dark:text-white text-[16px] font-semibold text-center mb-4">
                          Unlimited Access: Annual
                        </p>
                        {/* BETA: Price hidden
                        <h4 className="mb-5 mt-5 dark:text-white">
                          $881 <span className="text-[15px]">per annum</span>
                        </h4>
                        <p className="text-center">
                          <span className="text-sm text-gray-500 dark:text-gray-400 line-through mb-1 mr-1">
                            $1824
                          </span>
                          <span className="text-sm  font-medium text-green-600 dark:text-green-400">
                            Save over 50%
                          </span>
                        </p>
                        */}

                        <div className="p-4">
                          <table className="text-[14px] dark:text-white">
                            <tbody>
                              <tr className="">
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Unlimited 24/7 Access: Get round-the-clock
                                  availability to therapy whenever you need it
                                </td>
                              </tr>
                              <tr>
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Comprehensive Tools: Explore and use the full
                                  suite of speech therapy assessments and
                                  exercises
                                </td>
                              </tr>
                              <tr>
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Innovative Therapy: Engage in interactive
                                  avatar-led therapy session for a personalized
                                  experience
                                </td>
                              </tr>
                              <tr>
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Annual plan, renews yearly
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {/* BETA: Selection buttons removed - features only display */}

                        <div className="img-wrap img-2">
                          <img
                            src="/logo_for_pricing_dark2.jpeg"
                            alt="IzzyAI logo - AI-powered solution for Speech Language Therapy, offering tailored therapy for stammering, articulation, voice disorders, receptive disorders, and expressive disorders."
                            className="rounded-md dark:hidden"
                            width={"auto"}
                            height={"auto"}
                            loading="lazy"
                          />
                          <img
                            src="/logo_for_pricing_light2.jpeg"
                            alt="IzzyAI logo - AI-powered solution for Speech Language Therapy, offering tailored therapy for stammering, articulation, voice disorders, receptive disorders, and expressive disorders."
                            className="rounded-md hidden dark:block"
                            width={"auto"}
                            height={"auto"}
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel__face" id="slide3">
                <div className="card-3d-wrap mx-auto ">
                  <div className="card-3d-wrapper">
                    <div className="card-front">
                    <div className="pricing-wrap bg-[#cbd5e1] dark:bg-[#222A32] rounded-md shadow-lg hover:shadow-xl transition-shadow duration-300">
                      <p className="dark:text-white text-[16px] font-bold text-center mb-2">
                        Enterprise Plan
                      </p>
                      <p className="dark:text-white text-[13px] mb-4 text-center px-5">
                        Designed for Speech Language Therapy providers with a
                        large patient base.
                      </p>
                        <div className="p-4">
                          <table className="text-[14px] dark:text-white">
                            <tbody>
                              <tr className="">
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>

                                <td className="w-full text-start">
                                  Unlimited 24/7 Access: Get round-the-clock
                                  access to the IzzyAI application whenever you
                                  need it
                                </td>
                              </tr>
                              <tr>
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Comprehensive Tools: Explore and use the full
                                  suite of speech therapy assessments and
                                  exercises
                                </td>
                              </tr>
                              <tr>
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                  Innovative Therapy: Utilise interactive
                                  avatar-led therapy sessions providing patients
                                  with a personalized experience
                                </td>
                              </tr>
                              <tr>
                                <td className="flex justify-start pt-2">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    color="#28e9b4"
                                    size="2xs"
                                    className="scale-150"
                                    width={"20px"}
                                  />
                                </td>
                                <td className="w-full text-start">
                                Exclusive Dashboard: Seamlessly manage patient
                                records, schedule appointments, and track
                                treatments - all in one place
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <p className="mb-3">
                          <i className="uil uil-location-pin-alt size-22"></i>
                        </p>
                        <div className="flex justify-center">
                          <NavLink
                            to="/contactus"
                            className="link w-30 bg-[#111920] px-5 py-3 rounded-lg inline-block text-center relative "
                          >
                            <span className="gradient-text">
                              Contact Us For Pricing & Demo
                            </span>
                          </NavLink>
                        </div>

                        <div className="img-wrap img-2">
                          <img
                            src="/logo_for_pricing_dark2.jpeg"
                            alt="IzzyAI logo - AI-powered solution for Speech Language Therapy, offering tailored therapy for stammering, articulation, voice disorders, receptive disorders, and expressive disorders."
                            className="rounded-md dark:hidden"
                            width={"auto"}
                            height={"auto"}
                            loading="lazy"
                          />
                          <img
                            src="/logo_for_pricing_light2.jpeg"
                            alt="IzzyAI logo - AI-powered solution for Speech Language Therapy, offering tailored therapy for stammering, articulation, voice disorders, receptive disorders, and expressive disorders."
                            className="rounded-md hidden dark:block"
                            width={"auto"}
                            height={"auto"}
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Desktop: Show all 3 cards side by side */}
          <div className="hidden lg:flex lg:flex-row lg:gap-8 lg:justify-center lg:items-start lg:mt-20 xl:gap-12 2xl:gap-16 mb-10">
            {/* Monthly Card */}
            <div className="w-[370px] max-w-[370px]">
              <div className="card-3d-wrap">
                <div className="card-3d-wrapper">
                  <div className="card-front">
                      <div className="pricing-wrap bg-[#cbd5e1] dark:bg-[#222A32] rounded-md shadow-lg hover:shadow-xl transition-shadow duration-300">
                        <p className="dark:text-white text-[16px] font-semibold text-center mb-4">
                          Unlimited Access: Monthly
                        </p>
                      {/* BETA: Price hidden
                      <h4 className="mb-5 mt-5 dark:text-white">
                        $152 <span className="text-[15px]">per month</span>
                      </h4>
                      */}
                      <div className="p-4">
                        <table className="text-[14px] dark:text-white">
                          <tbody>
                            <tr className="">
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Unlimited 24/7 Access: Get round-the-clock
                                availability to therapy whenever you need it
                              </td>
                            </tr>
                            <tr>
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Comprehensive Tools: Explore and use the full
                                suite of speech therapy assessments and
                                exercises
                              </td>
                            </tr>
                            <tr>
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Innovative Therapy: Engage in interactive
                                avatar-led therapy session for a personalized
                                experience
                              </td>
                            </tr>
                            <tr>
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Rolling monthly plan,renews automatically
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {/* BETA: Selection buttons removed - features only display */}
                      <div className="img-wrap img-2">
                        <img
                          src="/logo_for_pricing_dark2.jpeg"
                          alt="IzzyAI logo"
                          className="rounded-md dark:hidden"
                          width={"auto"}
                          height={"auto"}
                          loading="lazy"
                        />
                        <img
                          src="/logo_for_pricing_light2.jpeg"
                          alt="IzzyAI logo"
                          className="rounded-md hidden dark:block"
                          width={"auto"}
                          height={"auto"}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Annual Card */}
            <div className="w-[370px] max-w-[370px]">
              <div className="card-3d-wrap mx-auto">
                <div className="card-3d-wrapper">
                  <div className="card-front">
                      <div className="pricing-wrap bg-[#cbd5e1] dark:bg-[#222A32] rounded-md shadow-lg hover:shadow-xl transition-shadow duration-300">
                        <p className="dark:text-white text-[16px] font-semibold text-center mb-4">
                          Unlimited Access: Annual
                        </p>
                      {/* BETA: Price hidden
                      <h4 className="mb-5 mt-5 dark:text-white">
                        $881 <span className="text-[15px]">per annum</span>
                      </h4>
                      <p className="text-center">
                        <span className="text-sm text-gray-500 dark:text-gray-400 line-through mb-1 mr-1">
                          $1824
                        </span>
                        <span className="text-sm  font-medium text-green-600 dark:text-green-400">
                          Save over 50%
                        </span>
                      </p>
                      */}
                      <div className="p-4">
                        <table className="text-[14px] dark:text-white">
                          <tbody>
                            <tr className="">
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Unlimited 24/7 Access: Get round-the-clock
                                availability to therapy whenever you need it
                              </td>
                            </tr>
                            <tr>
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Comprehensive Tools: Explore and use the full
                                suite of speech therapy assessments and
                                exercises
                              </td>
                            </tr>
                            <tr>
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Innovative Therapy: Engage in interactive
                                avatar-led therapy session for a personalized
                                experience
                              </td>
                            </tr>
                            <tr>
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Annual plan, renews yearly
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {/* BETA: Selection buttons removed - features only display */}
                      <div className="img-wrap img-2">
                        <img
                          src="/logo_for_pricing_dark2.jpeg"
                          alt="IzzyAI logo"
                          className="rounded-md dark:hidden"
                          width={"auto"}
                          height={"auto"}
                          loading="lazy"
                        />
                        <img
                          src="/logo_for_pricing_light2.jpeg"
                          alt="IzzyAI logo"
                          className="rounded-md hidden dark:block"
                          width={"auto"}
                          height={"auto"}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Enterprise Card */}
            <div className="w-[370px] max-w-[370px]">
              <div className="card-3d-wrap mx-auto">
                <div className="card-3d-wrapper">
                  <div className="card-front">
                    <div className="pricing-wrap bg-[#cbd5e1] dark:bg-[#222A32] rounded-md shadow-lg hover:shadow-xl transition-shadow duration-300">
                      <p className="dark:text-white text-[16px] font-bold text-center mb-2">
                        Enterprise Plan
                      </p>
                      <p className="dark:text-white text-[13px] mb-4 text-center px-5">
                        Designed for Speech Language Therapy providers with a
                        large patient base.
                      </p>
                      <div className="p-4">
                        <table className="text-[14px] dark:text-white">
                          <tbody>
                            <tr className="">
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Unlimited 24/7 Access: Get round-the-clock
                                access to the IzzyAI application whenever you
                                need it
                              </td>
                            </tr>
                            <tr>
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Comprehensive Tools: Explore and use the full
                                suite of speech therapy assessments and
                                exercises
                              </td>
                            </tr>
                            <tr>
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Innovative Therapy: Utilise interactive
                                avatar-led therapy sessions providing patients
                                with a personalized experience
                              </td>
                            </tr>
                            <tr>
                              <td className="flex justify-start pt-2">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  color="#28e9b4"
                                  size="2xs"
                                  className="scale-150"
                                  width={"20px"}
                                />
                              </td>
                              <td className="w-full text-start">
                                Exclusive Dashboard: Seamlessly manage patient
                                records, schedule appointments, and track
                                treatments - all in one place
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <p className="mb-3">
                        <i className="uil uil-location-pin-alt size-22"></i>
                      </p>
                      {/* <div className="flex justify-center">
                        <NavLink
                          to="/contactus"
                          className="link w-30 bg-[#111920] px-5 py-3 rounded-lg inline-block text-center relative "
                        >
                          <span className="gradient-text">
                            Contact Us For Pricing & Demo
                          </span>
                        </NavLink>
                      </div> */}
                      <div className="img-wrap img-2">
                        <img
                          src="/logo_for_pricing_dark2.jpeg"
                          alt="IzzyAI logo"
                          className="rounded-md dark:hidden"
                          width={"auto"}
                          height={"auto"}
                          loading="lazy"
                        />
                        <img
                          src="/logo_for_pricing_light2.jpeg"
                          alt="IzzyAI logo"
                          className="rounded-md hidden dark:block"
                          width={"auto"}
                          height={"auto"}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-gray-900/50 dark:bg-gray-900/80"
            onClick={toggleModal}
          ></div>

          {/* Modal Content */}
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700 w-full max-w-2xl mx-2">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-4 border-b dark:border-gray-600 border-gray-200">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                Upgrade To Annual
              </h3>
              <button
                onClick={toggleModal}
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-4 space-y-4">
              <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                Instructino to upgrade to annual plan
              </p>
              <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit aliquid vel praesentium repellendus recusandae fuga? Sunt maxime aliquid vitae dicta autem, facilis, minima illum incidunt tempore dolor laudantium consequuntur cumque doloribus quidem, possimus recusandae et illo! Impedit obcaecati ullam soluta molestiae sint quaerat quasi placeat, perferendis maxime laborum reiciendis ad.
              </p>
            </div>

            {/* Modal Footer */}
            <div className="flex items-center p-4 border-t dark:border-gray-600 border-gray-200 justify-between">
              <span className="text-black dark:text-white">cancel monthly plan </span>
              <button
                onClick={handleCanelMonthlyPlan}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Cancle Monthly Plan
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default RotatingPricingSection;
